export default {"src":"/_next/static/media/milker-logo.198d6b25.svg","height":210,"width":500,"blurWidth":0,"blurHeight":0};